import { render, staticRenderFns } from "./MolecularStructure.vue?vue&type=template&id=c9b817f0&lang=pug&"
import script from "./MolecularStructure.vue?vue&type=script&lang=js&"
export * from "./MolecularStructure.vue?vue&type=script&lang=js&"
import style0 from "./MolecularStructure.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports